
			<script lang="ts">
			import layout from '@/views/layouts/Auth/Main.vue'
			export default { layout }
			</script>
			<template>
		
    <Head>
        <title>{{ trans('Login') }}</title>
    </Head>

    <div class="sm:mx-auto sm:w-full sm:max-w-md">
        <Link href="/" class="block">
            <Logo class="mx-auto h-12 w-auto" size="lg" />
        </Link>
    </div>

    <div class="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 class="mt-6 text-center text-3xl font-bold text-gray-900">
            {{ trans('Student Login') }}
        </h2>
    </div>

    <Wrapper>
        <form class="space-y-6" @submit.prevent="studentLogin">
            <InputGroup
                id="passcode"
                v-model="studentForm.passcode"
                :label="trans('Student Passcode')"
                name="passcode"
                type="password"
            />

            <div>
                <Button type="submit" class="w-full" :loading="studentForm.processing">
                    {{ trans('Log In') }}
                </Button>
            </div>
        </form>
    </Wrapper>

    <div class="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 class="mt-6 text-center text-3xl font-bold text-gray-900">
            {{ trans('Login') }}
        </h2>
    </div>

    <Wrapper>
        <form class="space-y-6" @submit.prevent="login">
            <InputGroup
                id="email"
                v-model="form.email"
                :label="trans('Email')"
                name="email"
                autofocus
                type="email"
            />

            <InputGroup
                id="password"
                v-model="form.password"
                :label="trans('Password')"
                name="password"
                type="password"
                autocomplete="current-password"
            />

            <div class="flex items-center justify-between">
                <CheckboxGroup id="remember-me" v-model:checked="form.remember" name="remember-me">
                    {{ trans('Remember Me') }}
                </CheckboxGroup>
            </div>

            <div class="flex items-center justify-between">
                <div v-if="canResetPassword" class="text-sm">
                    <Anchor :href="route('password.request')" tag="link">
                        {{ trans('Forgot your password?') }}
                    </Anchor>
                </div>
            </div>

            <div>
                <Button type="submit" class="w-full" :loading="form.processing">
                    {{ trans('Log In') }}
                </Button>
            </div>
        </form>

        <div class="mt-6">
            <div class="relative">
                <div class="absolute inset-0 flex items-center">
                    <div class="w-full border-t border-gray-300" />
                </div>
                <div class="relative flex justify-center text-sm">
                    <span class="bg-white px-2 text-gray-500">{{ trans('Or') }}</span>
                </div>
            </div>
        </div>

        <div class="mt-6">
            <Button :href="route('register')" tag="link" variant="secondary" class="w-full">
                {{ trans('Sign Up Now') }}
            </Button>
        </div>
    </Wrapper>
</template>

<script setup lang="ts">
    import { Head, useForm } from '@inertiajs/vue3'
    import { Link } from '@inertiajs/vue3'
    import Wrapper from '@/views/layouts/Auth/Wrapper.vue'
    import InputGroup from '@/views/components/Form/InputGroup.vue'
    import CheckboxGroup from '@/views/components/Form/CheckboxGroup.vue'
    import Button from '@/views/components/Form/Button.vue'
    import Logo from '@/views/components/App/Logo.vue'
    import Anchor from '@/views/components/Anchor.vue'

    defineProps({
        canResetPassword: {
            type: Boolean,
            required: true,
        },
    })
    const form = useForm({
        email: '',
        password: '',
        remember: false,
    })
    const login = () =>
        form.post(route('login'), {
            onFinish: () => form.reset('password'),
        })
    const studentForm = useForm({
        passcode: '',
    })
    const studentLogin = () =>
        studentForm.post(route('student.login'), {
            onFinish: () => studentForm.reset('passcode'),
        })
</script>
